﻿import React, {Component, memo, Fragment, useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom';
import scrollLock from './scrollLock';
import { camelcase, formatImage, getName, getLayerImage, resizeElement, variants, getLastWordOfString, getHeader, getImageFormat, fetchItems, formatImageUrl, appendPlayButton, makeButtonVisible, fetchPlayerData, calcVotePercentage, fetchMoments } from './commonHelpers';
import { useOnClickOutside, useToggleCard, usePrevious, useHover } from './commonHooks'
import isEmpty from 'lodash.isempty';
import ReactMarkdown from "react-markdown/with-html";
import Carousel from './carousel';
import { throttle } from 'lodash'
import { motion, AnimatePresence } from "framer-motion";
import useClipboard from "react-use-clipboard";
import DotLoader from 'react-spinners/DotLoader';
import { useDispatch, useSelector } from 'react-redux'
import useDimensions from "react-use-dimensions";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { FirstRound, SecondRound, NFLNetworkLogo, CloseButton, ChevronDown, MomentNumber, ModalIcon, GreatestCharacters, GreatestGames, GreatestPlays, GreatestTeams, GreatestGameChangers, NFLShield, Cardinals, Falcons, Ravens, Bills, Panthers, Bears, Bengals, Browns, Cowboys, Broncos, Lions, Packers, Texans, Colts, Jaguars, Chiefs, Dolphins, Vikings, Patriots, Saints, Giants, Jets, Raiders, Eagles, Steelers, Rams, Chargers, FortyNiners, Seahawks, Buccaneers, Titans, Redskins, CheckIcon, SuperBowlIcon, ProBowlIcon, PlayerPosition, PlayerAwards, AllTimeTeamLogo, ThumbsUp } from './svgNFL100'
import ReactModal from "react-modal";

import {
  FacebookShareButton,
  TwitterShareButton,
} from 'react-share';
import useSWR from 'swr';

export const ShareButton = ({ url }) => {
  const [isToggled, toggleModal] = useState(false);
  return (
    <Fragment>
      <a className="d3-o-button__cta-link d3-o-button__cta-link--yellow" onClick={e => toggleModal(true)} >
      SHARE THIS MOMENT      
      </a>
      {
        isToggled ? <ShareModal url={url} toggleModal={toggleModal} /> : null
      }
    </Fragment>
  )
}

export const ShareModal = ({ url, toggleModal }) => {

  return (
    createPortal(
      <div
        className="modal modal--share d3-c-moments__modal">
        <div className="modal__overlay">
          <motion.div
            variants={variants.modal}
            initial="hidden"
            animate="visible"
            exit={{ opacity: 0 }}
            className="modal__container"
          >
            <button className='d3-o-button d3-o-button__close' onClick={() => toggleModal(false)} >
              <svg
                id="Layer_4"
                data-name="Layer 4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <polygon points="13.41 12 18.21 7.21 16.79 5.79 12 10.59 7.21 5.79 5.79 7.21 10.59 12 5.79 16.79 7.21 18.21 12 13.41 16.79 18.21 18.21 16.79 13.41 12" />
                <rect fill="none" width="24" height="24" />
                <rect fill="none" width="24" height="24" />
              </svg>
            </button>
            <ShareList url={url} title={"Share this moment:"}/>
          </motion.div>
        </div>
      </div>,
      document.querySelector("body")
    )
  )
}

export const ShareList = ({ url, urlText, title, hashtag = 'AllTimeTeam' }) => {
  const [isCopied, setCopied] = useClipboard(url);
  return (
    <div
      className="modal__list"
    >
      <div className="modal__title" >{title}</div>
      <div className="modal__button-group">
        <FacebookShareButton url={url} quote={urlText}>
          <svg xmlns="http://www.w3.org/2000/svg" className="modal__social facebook" viewBox="0 0 24 24">
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M14.86 12l.32-2.33h-2.46V8.54c0-.72.2-1.21 1.23-1.21h1.32V5.1a17.59 17.59 0 0 0-1.92-.1 3 3 0 0 0-3.2 3.29v1.38H8V12h2.15v7h2.57v-7h2.14" fillRule="evenodd" />
          </svg>
          <div className="modal-label">FACEBOOK</div>
        </FacebookShareButton>
        <TwitterShareButton hashtags={[hashtag, 'NFL100']} title={urlText} url={url} >
          <svg xmlns="http://www.w3.org/2000/svg" className="modal__social twitter" viewBox="0 0 24 24">
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M18.92 7.71a5.66 5.66 0 0 1-1.63.45 2.84 2.84 0 0 0 1.25-1.57 5.68 5.68 0 0 1-1.8.69 2.84 2.84 0 0 0-4.91 1.94 2.87 2.87 0 0 0 .07.65A8.06 8.06 0 0 1 6 6.89a2.84 2.84 0 0 0 .88 3.79 2.83 2.83 0 0 1-1.29-.36 2.84 2.84 0 0 0 2.28 2.78 2.82 2.82 0 0 1-1.28 0 2.84 2.84 0 0 0 2.65 2 5.7 5.7 0 0 1-3.53 1.22 5.84 5.84 0 0 1-.68 0 8.08 8.08 0 0 0 12.48-6.78v-.37a5.78 5.78 0 0 0 1.42-1.47" fillRule="evenodd" />
            <path fill="none" d="M0 0h24v24H0z" />
          </svg>
          <div className="modal-label">TWITTER</div>
        </TwitterShareButton>
        <div onClick={setCopied} aria-label="copy" role="button" tabIndex="0" className="SocialMediaShareButton SocialMediaShareButton--copy-url">
          <svg xmlns="http://www.w3.org/2000/svg" version="1" className="modal__social url" viewBox="0 0 60 60">
            <path d="M45 17l-6-6c-1-2-4-2-5 0L22 23c-2 1-2 4 0 5l2-2v-1l12-12h1l6 6v1L31 32h-1l-1-1-2 2 1 1c1 2 4 2 5 0l12-12c2-1 2-4 0-5z" />
            <path d="M38 32l-2 2v1L24 47h-1l-6-6v-1l12-12h1l1 1 2-2-1-1c-1-2-4-2-5 0L15 38c-2 1-2 4 0 6l6 5c1 2 4 2 5 0l12-11c2-2 2-5 0-6z" />
          </svg>
          <div className="modal-label">{isCopied ? "COPIED!" : "COPY LINK"}</div>
        </div>
      </div>
    </div>  
  )
}

export const ModalCarousel = ({ selectedPhotoId, toggleModal, handleOutsideClick, elements = []}) => {

  const carousel = useRef(null);
  const root = document.body.querySelector('.d3-l-wrap');
  const mainDom = document.body.querySelector('main');
  const lazyLoadInstance = null
  const viewType = 'carousel'

  const findPhotoIndex = (id, elements) => {
    return elements.findIndex(photo => {
      return photo._entityId === id;
    });
  };

  const updateDimensions = carousel => {
    if (carousel) {
      const imageWidth = carousel.querySelector('.glide__slide--active') && carousel.querySelector('.glide__slide--active').querySelector('.d3-o-media-object__figure').clientWidth;
      if (imageWidth > 0) {
        carousel.querySelector('.d3-o-carousel__arrows.glide__arrows').style.width = `${imageWidth}px`;
      }
    }
  };

  const [id, setId] = useState(findPhotoIndex(selectedPhotoId, elements))
  const type = "carousel"

  useEffect(() => {
    scrollLock.disablePageScroll(mainDom)
    root.style.filter = "brightness(30%)";
    root.addEventListener('mousedown', handleOutsideClick);
    const mainElement = root.querySelector('main');

    if (mainElement) {
      mainElement.style.pointerEvents = "none"
    }

    new Carousel({
      elements: [carousel.current],
      startPoint: id,
    });

    updateDimensions(carousel.current)

    window.addEventListener("resize", throttle(() => updateDimensions(carousel.current), 500));

    return () => {
      root.style.filter = "brightness(100%)";
      root.removeEventListener('mousedown', handleOutsideClick);
      if (mainElement) {
        mainElement.style.pointerEvents = "initial";
      }
      scrollLock.enablePageScroll(mainDom);
      window.removeEventListener("resize", updateDimensions);
    }
  }, [])


  return createPortal(
    <AnimatePresence>
      <motion.div
        key="modal"
        variants={variants.slideUp}
        className="d3-c-photo-album__carousel-container"
        initial="hidden"
        animate="visible"
        exit={{ opacity: 0 }}
      >
        <div
          className="d3-o-carousel glide"
          data-count={elements.length}
          data-viewtype="single"
          data-slides="1"
          data-autoplay="false"
          data-overlay="true"
          ref={carousel}
        >
          <CloseButton toggleModal={toggleModal} />
          <div className="glide__track" data-glide-el="track">
            <ul className="d3-o-carousel__slides glide__slides">
              {
                elements.length > 0 &&
                elements.map((photo, index) => {
                  const singleImage = formatImage(photo.image, { format: "t_photo_album", extension: "w_800,h_450" });
            
                  const { fields, references, tags } = photo
                  const { person } = references || {}
                  const { url } = fields || {}          

                  return (
                    <MediaObject
                      key={index}
                      id={photo._entityId}
                      toggleModal={null}
                      className="d3-o-media-object--carousel"
                      type={type}
                    >
                      {
                        url && url.url ?
                          <a className="d3-o-media-object__figure-link" draggable="true" data-href={url.url} href={url.url}>
                            <MediaObjectFigure
                              lazyLoadInstance={lazyLoadInstance}
                              type={type}
                            >
                              {singleImage &&
                                <Picture type={type} image={singleImage} isLazy={lazyLoadInstance} />}
                            </MediaObjectFigure>
                          </a>
                          :
                          <MediaObjectFigure
                            lazyLoadInstance={lazyLoadInstance}
                            type={type}
                          >
                            {singleImage &&
                              <Picture type={type} image={singleImage} isLazy={lazyLoadInstance} />}
                          </MediaObjectFigure>
                      }
                      {
                        !isEmpty(fields) && <MediaObjectBody {...fields} tags={tags} type={type} person={person} viewType={viewType} index={index} />
                      }
                    </MediaObject>
                  )
                }
              )}
            </ul>
            <div className="d3-o-carousel__arrows glide__arrows" data-glide-el="controls">
              <button className="d3-o-button__arrow d3-o-button__arrow--left glide__arrow glide__arrow--left" data-glide-dir="<">
                <ChevronDown/>
              </button>
              <button className="d3-o-button__arrow d3-o-button__arrow--right glide__arrow glide__arrow--right" data-glide-dir=">">
                <ChevronDown />
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>,
    document.querySelector("body")
  );
  
}


export const MediaObject = props => {
  const { type, className, children, toggleModal, clickFn } = props

  function onClick(clickFn, toggleModal, props, e) {
    if (!clickFn && !toggleModal) {
      return null
    }

    return toggleModal ? toggleModal(props) : clickFn(e)
  }

  return (
    <motion.div
      initial={type === "moment" && { y: 20, opacity: 0 }}
      animate={type === "moment" && { y: 0, opacity: 1 }}
      className={`d3-o-media-object ${type ? `d3-o-media-object--${type}` : ""} ${className ? className : ""}`}
      onClick={(e) => onClick(clickFn, toggleModal, props, e)}>
      {children}
    </motion.div>
  )
}

export const MediaObjectFigure = props => {
  const { lazyLoadInstance, type, baseClass, children, className } = props

  const [figure, { width }] = useDimensions();

  useEffect(() => {
    if (type === "moment" || type === "details") {
      window.removeEventListener('resize', () => resizeElement(figure, type))
    }
    else {
      lazyLoadInstance && lazyLoadInstance.update();
    }
    return () => {
      if (type === "moment" || type === "details") {
        window.removeEventListener('resize', () => resizeElement(figure, type))
      }
      else {
        lazyLoadInstance && lazyLoadInstance.update();
      }
    }
  }, [])

  return (
    <figure
      className={`d3-o-media-object__figure ${className ? className : ""} ${baseClass ? `${baseClass}__figure` : ""}`}
      style={type === "moment" ? { minHeight: width } : { minHeight: 'auto' }}
      ref={figure}
    >
      {children}
    </figure>
  )
}

export const MediaLayerGroup = ({ children, baseClass, isMobile, className }) => {
  const group = useRef(null)
  const { isHovered, toggleHover } = useHover(group, isMobile)

  return (
    <motion.div
      onHoverStart={(e) => toggleHover(e)}
      onHoverEnd={(e) => toggleHover(e)}
      animate={isHovered ? "onHoverStart" : "onHoverEnd"}
      className={`${baseClass ? `${baseClass}__layers` : ""} ${className ? className : ""}`}
      ref={group}
      {...isMobile && { 'data-type': 'parallax' }}
    >
      {children}
    </motion.div>
  )
}

export const MediaLayer = memo(props => {
  const { layerNumber, baseClass, isLazy, image, variants, type = "moment" } = props

  let layerName;
  switch (layerNumber) {
    case "two":
      layerName = "first-layer"
      break;
    case "three":
      layerName = "third-layer"
      break;
    default:
      layerName = ""
  }

  return (
    <motion.div
      transition={{ duration: 2 }}
      variants={image && image.isFallback ? null : variants}
      className={`${baseClass}__layer ${baseClass}__layer--${layerNumber}`}
      {...props.isMobile && { 'data-animation': layerName }}
    >
      {
        type === "player" ?
          <PlayerPicture  image={image} /> :
          <Picture  type={type} image={image} isLazy={isLazy} />
      }
    </motion.div>
  )
}, imagesAreEqual)

export const MediaObjectBody = ({ caption, callout, headline, description, date, photographer, viewType, person, type, tags, index }) => {
  return (
    <div className="d3-o-media-object__body">
      {
        type !== "moment" && date && <div className="d3-o-media-object__date"> {`${date}`}</div>
      }
      {
        type !== "moment" && headline &&
        <div className="d3-o-media-object__headline">
          <ReactMarkdown
            escapeHtml={false}
            source={headline} />
        </div>
      }
      {
        type !== "moment" && viewType === "carousel" && description &&
        <div className="d3-o-media-object__description">
          <ReactMarkdown
            escapeHtml={false}
            source={description} />
        </div>
      }
      {
        type !== "moment" && viewType === "carousel" && caption &&
        <div className="d3-o-media-object__caption">
          <ReactMarkdown
            escapeHtml={false}
            source={caption} />
        </div>
      }
      {
        type !== "moment" && viewType === "carousel" && photographer &&
        <div className="d3-o-media-object__photographer">
          {`Photo by ${photographer}`}
        </div>
      }
      {
        type === "moment" && person && person.length > 0 && <PersonList index={index} personList={person} />
      }
      {
        type === "moment" && callout &&
        <div className="d3-o-media-object__callout">
          <ReactMarkdown
            escapeHtml={false}
            source={callout} />
        </div>
      }
      {
        type === "moment" && <Tags tags={tags} />
      }
    </div>
  )
};

const PersonList = ({ personList, index }) => {
  const thumbnailFormat = { format: "t_thumb_squared", extension: "f_auto" }

  const name = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    }
  }

  const photo = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        delay: 0.3,
      }
    }
  }

  return (
    <div className="d3-o-media-object__person d3-o-person">
      <motion.div
        variants={photo}
        transition={{ duration: 2 }}
        initial="hidden"
        animate="visible"
        className="d3-o-person__thumbnail-list">
        {
          personList.map((person, index) => {
            const headshot = formatImage(person.thumbnail, thumbnailFormat);
            return (
              <div key={index} className="d3-o-person__thumbnail">
                <Picture isLazy={false} image={headshot} />
              </div>
            )
          })
        }                   
      </motion.div>
      <motion.div
        variants={name}
        transition={{ duration: 2 }}
        initial="hidden"
        animate="visible"
        className="d3-o-person__name-list">
        <span className="d3-o-person__by">by </span>
        {
          personList.map((person, index) => {
            const name = getName(person.fields)

            return (
              name ? <span key={index} className="d3-o-person__name">{` ${name}`}</span> : null
            )
          })
        }
      </motion.div>          
    </div>  
  )
}

const Tags = ({ tags }) => {

  const { celebrities, teams } = tags
  const normalizedTeams = teams && teams.map(name => getLastWordOfString(name))
  const mergedTags = [...(celebrities ? celebrities : []), ...(normalizedTeams ? normalizedTeams : [])]

    return (
      <div className="d3-o-media-object__tags-container" >
        {
          mergedTags.map((type, index) => {
            return (
              <span className="d3-o-media-object__tag" key={index}>
                {type}
              </span>
            )
          })
        }
      </div >
    )
}

export const Picture = memo(props => {
  const {
    isLazy = true,
    image,
    type,
    clickFn
  } = props

  if (!image) {
    return null;
  }

  const imageVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1
    }
  };

  return (
    <picture onClick={clickFn ? clickFn : null} is-lazy={"/e_blur:1000,q_1,f_auto/e_grayscale/"}>
      {type === "moment" ? (
        <motion.img
          alt={image.title ? image.title : ""}
          variants={imageVariants}
          initial="hidden"
          animate="visible"
          transition={{
            default: { duration: 2, ease: "easeInOut" },
            fill: { duration: 2, ease: [1, 0, 0.8, 1] }
          }}
          className={`img-responsive ${isLazy ? "lazy" : ""}`}
          src={image.highQuality}
        />
      ) : (
          <img
            alt={image.title ? image.title : ""}
            className={`img-responsive ${isLazy ? "lazy" : ""}`}
            data-src={isLazy && image.highQuality}
            src={image.highQuality}
          />
        )}
    </picture>
  );
}, imagesAreEqual);

export const PlayerPicture = props => {
  const {
    image,
  } = props

  if (!image) {
    return null;
  }

  const [picture, setPicture] = useState(image)
  const [counter, setCounter] = useState(0)
  useEffect(() => {
    if (image.highQuality !== picture.highQuality) {
      setCounter(counter + 1)
      setPicture(image)
    }
  }, [image]);

  return (
    <picture is-lazy={"/e_blur:1000,q_1,f_auto/e_grayscale/"}>
    <TransitionGroup className="d3-o-card__picture-wrapper">
      <CSSTransition key={picture.title} timeout={1000} classNames="player-picture">
          <img
            alt={picture.title ? picture.title : ""}
            className={`img-responsive ${counter === 0 ? "first" : ""}`}
            src={picture.highQuality}
          />
        </CSSTransition>
      </TransitionGroup>
    </picture>
  );
}

function imagesAreEqual(prevProps, nextProps) {
  return prevProps.image === nextProps.image;
}

const VideoOverlay = ({ baseClass }) => {
  return (
    <div className={`${baseClass}__video-overlay`} >
      <svg className="d3-o-button__video" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">  
        <path d="M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm-2 15V8l6 4z" opacity=".4"></path>
        <path fill="#fff" d="M10 16l6-4-6-4v8z"></path>
        <path fill="none" d="M0 0h24v24H0z"></path>
        <path fill="#fff" d="M12 2A10 10 0 1 1 2 12 10 10 0 0 1 12 2m0-1a11 11 0 1 0 11 11A11 11 0 0 0 12 1z"></path>
      </svg>
    </div>  
  )
}

const Flare = () => {
  return (
    <svg className="d3-c-hero__flare" viewBox="0 0 1269 273" width="1269" height="312" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path className="d3-c-hero__angle" d="M1269 0v312H304L1269 0zM748.457 122.05l-88.182 22.391L0 312h159l502.025-161.741 87.432-28.209z"></path>
      </g>
    </svg>
  )
}

export const MomentTextContainer = ({ headline, roofline, baseClass }) => {
  if (!headline && !roofline) {
    return null
  }

  return (
    <div className={`${baseClass}__gradient`} >
      <div className={`${baseClass}__text-container`}>
        {
          roofline &&
          <div className={`${baseClass}__roofline`}>
            {roofline}
          </div>
        }
        {
        headline &&
        <div className={`${baseClass}__headline`}>
            {headline}
          </div>
        }
      </div>
      <Flare />
    </div>  
  )
}

export const GreatestLogo = ({ logoType }) => {
  switch (logoType) {
    case "none":
      break;
    case "100 greatest characters":
      return (
        <GreatestCharacters fill={"#fff"} />
      )
    case "100 greatest games":
      return (
        <GreatestGames fill={"#fff"} />
      )
    case "100 greatest plays":
      return (
        <GreatestPlays fill={"#fff"} />
      )
    case "100 greatest teams":
      return (
        <GreatestTeams fill={"#fff"} />
      )
    case "100 greatest game-changers":
      return (
        <GreatestGameChangers fill={"#fff"} />
      )
    default:
      return null
  }
}

export const TeamLogos = ({ teamName }) => {
  return (
    <motion.span
      className="nfl-o-team-logo"
    >
      {(() => {
        switch (teamName) {
          case "Arizona Cardinals":
          return <Cardinals/>
          case "Atlanta Falcons":
            return <Falcons />
          case "Baltimore Ravens":
            return <Ravens />
          case "Buffalo Bills":
            return <Bills /> 
          case "Carolina Panthers":
            return <Panthers />
          case "Chicago Bears":
            return <Bears />
          case "Cincinnati Bengals":
            return <Bengals />
          case "Cleveland Browns":
            return <Browns />
          case "Dallas Cowboys":
            return <Cowboys />
          case "Denver Broncos":
            return <Broncos />
          case "Detroit Lions":
            return <Lions />
          case "Green Bay Packers":
            return <Packers />
          case "Houston Texans":
            return <Texans />
          case "Indianapolis Colts":
            return <Colts />
          case "Jacksonville Jaguars":
            return <Jaguars />
          case "Kansas City Chiefs":
            return <Chiefs />
          case "Miami Dolphins":
            return <Dolphins />
          case "Minnesota Vikings":
            return <Vikings />
          case "New England Patriots":
            return <Patriots />
          case "New Orleans Saints":
            return <Saints />
          case "New York Giants":
            return <Giants />
          case "New York Jets":
            return <Jets />
          case "Oakland Raiders":
            return <Raiders />
          case "Philadelphia Eagles":
            return <Eagles />
          case "Pittsburgh Steelers":
            return <Steelers />
          case "Los Angeles Rams":
            return <Rams />
          case "Los Angeles Chargers":
            return <Chargers />
          case "San Francisco 49ers":
            return <FortyNiners />
          case "Seattle Seahawks":
            return <Seahawks />
          case "Tampa Bay Buccaneers":
            return <Buccaneers />
          case "Tennessee Titans":
            return <Titans />
          case "Washington Redskins":
            return <Redskins />
          case "All Teams":
            return <NFLShield />
          default:
            return null
        }
      })()}
    </motion.span>    
  )
}

export const Modal = ({ list, toggleSelections, toggleModal, className }) => {
  const modalList = useRef(null);

  useOnClickOutside(modalList, () => toggleModal(false));

  const header = getHeader(list);

  return createPortal(
    <div
      className={`modal ${className ? className : ""} d3-c-moments__modal`}>
      <div className="modal__overlay">
        <motion.div
          variants={variants.modal}
          initial="hidden"
          animate="visible"
          exit={{ opacity: 0 }}
          className="modal__container"
        >
          <CloseButton toggleModal={toggleModal} />
          <div className="modal__header">{header}</div>
          <div
            ref={modalList}
            className="modal__list"
          >
            {
              list &&
              list.map(item => {
                return (
                  <ListItem key={item.id} item={item} header={header} toggleSelections={toggleSelections} />
                )
              })
            }
          </div>
        </motion.div>
      </div>
    </div>,
    document.querySelector("body")
  );
}

export const Selector = props => {
  const { list, toggleModal, label, baseClass, hasModalIcon = true } = props;

  const clickFn = () => toggleModal(list)

  return (
    <div
      className={`${baseClass}__moments-selector`}
      onClick={clickFn}
    >
      <span>{label}</span>
      {hasModalIcon &&
        <span className={`${baseClass}__modal-icon`}>
          <ModalIcon />
        </span>
      }
    </div>
  );
};


export const ListItem = ({ item, header, toggleSelections }) => {
  return (
    <button
      className={`modal__list-item ${item.selected ? "modal__list-item--selected" : ""}`}
      onClick={() => toggleSelections(item)}
    >
      {
        header === "Select a Team"
          ? <div className="modal__title modal__title--team">
            <TeamLogos teamName={item.title} />
            <span className="modal__team-name">{`${item.title}`}</span>
          </div>
          : <div className="modal__title">{`${item.title}`}</div>
      }
    </button>
  )
}

export function Card(props) {
  const { cardType, children, isSelected } = props;

  const [figure, { width }, node] = useDimensions();

  useEffect(() => {
    if (node) {
      const height = `${width * 1.5}px`
      node.style.height = height
    }
  }, [node, width])

  return (
    <div ref={figure} className={`d3-o-card ${cardType ? `d3-o-card--${cardType}` : ""} ${isSelected ? 'selected' : ''}`}>
      {children}
    </div>
  );
}

export const Banner = memo(props => {
  const {
    currentPosition,
    description,
    type = 'banner',
    baseClass = "d3-o-roster"
  } = props;

  const responsive = useSelector(state => state.responsive);
  const { isDesktop, isPhone } = responsive || {}
  const { thumbnail, positionLong } = currentPosition || {}

  const backgroundList = useSelector(state => state.backgrounds)

  const background = backgroundList && backgroundList.length > 0 ? backgroundList[0] : null

  const { landscape, portrait } = getImageFormat("", !isDesktop ? "w_300,f_png" : "f_png");

  const backgroundImage =
    background &&
    formatImage(background, !isDesktop ? portrait : landscape);

  const topImage =
    thumbnail &&
    formatImage(thumbnail, !isDesktop ? portrait : landscape);

  return (

    <MediaObject
      className={`${baseClass}__banner`} 
      type={type}
    >
      <MediaObjectFigure baseClass={baseClass} type={type}>
        <MediaLayerGroup
          isMobile={isPhone}
          baseClass={baseClass}
        >
          <div className={`${baseClass}__overlay`}>
            <div className={`${baseClass}__info-container`}>
              <div className={`${baseClass}__info-position`}>{positionLong}</div>
              <div className={`${baseClass}__info-time-start`}>{description}</div>
              <div className={`${baseClass}__tune-in`}>Tune in on <span className="d3-o-logo__nfl-network"><NFLNetworkLogo /></span></div>
            </div>
          </div>
          <MediaLayer
            type={type}
            baseClass={baseClass}
            layerNumber="two"
            isLazy={false}
            image={topImage}
          />
          <MediaLayer type={type} baseClass={baseClass} image={backgroundImage} layerNumber="three" isLazy={false} />
        </MediaLayerGroup>
      </MediaObjectFigure>
    </MediaObject>
  )
})

export function Player(props) {
  const {
    isSelected,
    clickFn,
    selectionAvailable,
    currentPlayer,
    type = 'player',
  } = props;

  const responsive = useSelector(state => state.responsive)
  const { isPhone, isDesktop } = responsive || {}
  const { fields, thumbnail } = currentPlayer || {}

  const { backgroundType } = fields || {};
  const baseClass = "d3-o-card"

  const backgroundList = useSelector(state => state.backgrounds)
  const parsed = backgroundType && typeof backgroundType === "number" ? parseInt(backgroundType, 10) : 0;
  const background = backgroundList && backgroundList.length > 0 ? backgroundList[parsed] : null

  const { square, portrait } = getImageFormat(null, !isDesktop ? "w_400,f_png" : "w_600,f_png");
  const { landscape } = getImageFormat(null, !isDesktop ? "q_70,w_300,f_auto" : "q_70,w_600,f_auto" );

  const backgroundImage =
    background &&
    formatImage(background, !isDesktop ? portrait : landscape);

  const playerImage =
    thumbnail &&
    formatImage(thumbnail, square);

  return (
    <MediaObject
        clickFn={clickFn}
      className={`${baseClass} ${
        isSelected ? "selected" : ""
        }`}
      type={type}
    >
      <MediaObjectFigure baseClass={baseClass} type={type}>
        <MediaLayerGroup
          isMobile={!isDesktop}
          baseClass={baseClass}
        >
          <div className="d3-o-card__overlay"/>
          {
            type !== "prediction" || type !== "spotlight"
              ? <PlayerCallout type={type} isSelected={isSelected} isMobile={!isDesktop} selectionAvailable={selectionAvailable} fields={fields} />
              : null
          }
          {type === 'card' &&
            <div className={`d3-o-card__layer d3-o-card__flare`}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 650 300">
                <path d="M-1 3v296h686.7L-1 3zm370.4 115.8l62.8 21.2L902 299H788.9L431.6 145.6l-62.2-26.8z" fill="#79797959" fillRule="evenodd" />
              </svg>
            </div>
          }

          <MediaLayer
              type={type}
              baseClass={baseClass}
              layerNumber="two"
              isLazy={false}
              image={playerImage}
            />
          {type !== "spotlight" && <MediaLayer type={type} baseClass={baseClass} image={backgroundImage} layerNumber="three" isLazy={false} />}
        </MediaLayerGroup>
      </MediaObjectFigure>
      
      </MediaObject> 
  );
}

export function PlayerCallout({ isSelected, selectionAvailable, fields, isMobile, type }) {
  const { firstName, lastName, playerPosition, yearsActive } = fields || {}

  return (
    <div className={`d3-o-card__layer d3-o-callout d3-o-callout--${type}`}>
      <div className="d3-o-callout__container">
        {selectionAvailable && (
          <PlayerToggle selected={isSelected} />
        )}
        <PlayerName
          firstName={firstName}
          lastName={lastName}
          playerPosition={playerPosition}
          yearsActive={yearsActive}
        />
        {type === "player" && <KeyAccomplishments count={2} fields={fields}/>}
      </div>     
    </div> 
  )
}

export const KeyAccomplishments = ({fields, count}) => {
  const { mvpData, allProData, proBowlData, championshipData, superBowlMvpData, hallOfFameData } = fields || {}
  const careerAwards = [
    { name: 'mvp', data: mvpData && `${mvpData} NFL MVP` },
    { name: 'allPro', data: allProData && `${allProData}x All Pro` },
    { name: 'proBowl', data: proBowlData && `${proBowlData}x Pro Bowl` },
    { name: 'championship', data: championshipData },
    { name: 'superBowlMvp', data: superBowlMvpData && `${superBowlMvpData} Super Bowl MVP` },
    { name: 'hallOfFame', data: hallOfFameData && `Inducted into HOF ${hallOfFameData}` }
  ]

  return (
    <div className="d3-o-card__key-stats d3-o-key-stats">
      {
        careerAwards && careerAwards.filter(stat => stat.data).map((filteredStat, index) => {
          if (index < count) {
            return (
              <div className="d3-o-key-stats__accomplishment" key={index}>
                <span className="d3-o-key-stats__icon">
                  <PlayerAwards award={filteredStat.name} />
                </span>
                <span className="d3-o-key-stats__value">{filteredStat.data}</span>
              </div>
            )
          }
        })
      }
    </div>  
  )
}

export const KeyStats = ({ fields }) => {

  const { keyStatsOne, keyStatsTwo, keyStatsThree, keyStatsFour, keyStatsFive, keyStatsSix } = fields || {}
  const statsArray = [keyStatsOne, keyStatsTwo, keyStatsThree, keyStatsFour, keyStatsFive, keyStatsSix]

  return (
    <div className="d3-o-card__key-stats d3-o-key-stats">
      {
        statsArray &&
        statsArray
          .filter(stat => stat)
          .map((filteredStat, index) => {
            return (
              <div className="d3-o-key-stats__stat" key={index}>
                <span className="d3-o-key-stats__value">{filteredStat}</span>
              </div>
            )
        })
      }
    </div>
  )
}

const Teams = ({ teamsData }) => {
  const teams = teamsData.split(', ')

  return (
    teams.map((team, index) => {
      return (
        <p key={index} className={`d3-o-player__data-section-body`}>{team}</p>
      )
    })
  )
}

export function CardImage(props) {
  const {
    image,
    entityId,
    imageFormat,
    isSelected,
    clickFn,
    openCard
  } = props;
  const responsive = useSelector(state => state.responsive)
  const { isDesktop } = responsive || {}
  const img = image && formatImage(image, imageFormat);

  const ref = useRef(null)
  const { isHovered, toggleHover } = useHover(ref, false)

  return (
    <motion.div
      className={`d3-o-card__image`}
    >
      {
        clickFn && (
          <CardToggle
            isSelected={isSelected}
            entityId={entityId}
            clickFn={clickFn}
          />
        )
      }
      {img && (
        <picture ref={ref} onClick={openCard}>
          <motion.img
            onHoverStart={(e) => toggleHover(e)}
            onHoverEnd={(e) => toggleHover(e)}
            animate={isHovered ? "onHoverStart" : "onHoverEnd"}
            transition={{ default: { duration: 1.5, ease: "easeInOut" } }}
              alt={img.title ? img.title : ""}
              variants={variants.numberVariant}
              className={`img-responsive`}
              src={img.highQuality}
            />
        </picture>
        )
      }
    </motion.div>
  );
}

export function PlayerPicker(props) {
  const {
    image,
    clickFn,
    fields,
    isSelected,
    isCurrent,
    text
  } = props;

  const baseClass = "d3-o-player-picker"
  const thumbnailImage = image && formatImage(image, getImageFormat(null, 'h_50,w_50,f_png').square);

  const backgroundList = useSelector(state => state.backgrounds)

  const background = backgroundList && backgroundList.length > 0 ? backgroundList[0] : null

  const type = "picker"
  const backgroundImage =
    background &&
    formatImage(background, getImageFormat(null, 'h_50,w_50,f_auto').square);

  const { firstName, lastName } = fields || {};
  return (
    <div
      onClick={e => clickFn(e)}
      className={`${baseClass} ${isCurrent ? "current" : ""} ${isSelected ? "selected" : ""}`}
    >
      <MediaObject className={`${baseClass}__container`}>
        <MediaObjectFigure>
          <MediaLayer
            type={type}
            baseClass={baseClass}
            layerNumber="two"
            isLazy={false}
            image={thumbnailImage}
          />
          <MediaLayer type={type} baseClass={baseClass} image={backgroundImage} layerNumber="three" isLazy={false} />
        </MediaObjectFigure>
        <div className={`d3-o-media-object__body d3-o-player-picker__name-container`}>
          <div className={`d3-o-player-picker__first-name`}>{firstName}</div>
          <div className={`d3-o-player-picker__last-name`}>{lastName}</div>
        </div>
      </MediaObject>
      {text && <div className="d3-o-player-picker__text">{text}</div>}
    </div>
  );
}

export function PredictionCTA(props) {
  const { predictionText, isEnabled, positionLong, clickFn } = props;
  return (
    <div className="d3-o-roster__prediction-cta">
      <div className="d3-o-roster__prediction-text">
        {isEnabled
          ? `Make your NFL All-Time Team ${positionLong} predictions`
          : predictionText}
      </div>
      <Button
        className="d3-o-roster__prediction-button"
        isEnabled={isEnabled}
        clickFn={clickFn}
        buttonText="PREDICT NOW"
      />
    </div>
  );
}

export function CardText({ headline, homeTeam }) {
  return (
    <div className="d3-o-card__text-container">
      <div className="d3-o-card__headline">{headline}</div>
      <div className="d3-o-card__game-info">{homeTeam}</div>
    </div>
  );
}


const CardToggle = props => {
  const { isSelected, clickFn } = props;

  return (
    <div onClick={clickFn} className="d3-o-card__toggle-container">
      <ThumbsUp className="d3-o-card__toggle" isSelected={isSelected} />
    </div>
  )
};

const PlayerToggle = ({selected}) => {
  return (
    <div className="d3-o-card__check-icon">
      <CheckIcon selected={selected} />
    </div>
  )
}

export function Button({ isEnabled, buttonText, clickFn, className, color = 'yellow' }) {
  return (
    <button
      onClick={clickFn}
      className={`d3-o-button d3-o-button--${
        isEnabled ? "enabled" : "disabled"
        } d3-o-button__cta-link--${color} ${className ? className : ""}`}
      disabled={isEnabled ? false : true}
    >
      {buttonText}
    </button>
  );
}

export function SelectionFooter({
  baseClass,
  children
}) {
  return (
    <div className={`${baseClass}__footer ${children && children.length > 1 ? "" : "center"}`}>
      {children}
    </div>
  );
}

export function SelectionCounter({ baseClass, children }) {
  return <div className={`${baseClass}__selection-wrapper`}>{children}</div>;
}

export function SelectionLabel(props) {
  const { labelTextFirst, labelTextSecond, baseClass, labelValue, labelColor } = props;
  return (
    <div className={`${baseClass}__selection-label-container`}>
      <div className={`${baseClass}__selection-label`}>
        <div className={`${baseClass}__selection-label--first`}>{labelTextFirst}</div>
        <div className={`${baseClass}__selection-label--second`}>{labelTextSecond}</div>
      </div>
      <div className={`${baseClass}__selection-value ${labelColor ? labelColor : ""}`}>{labelValue}</div>
    </div>
  );
}

export function ProgressBar({ round, groupOneData, groupTwoData }) {
  const maxCount = useSelector(state => state.maxCount)
  const groupLength = round === "1" ? groupOneData && groupOneData.length : groupTwoData && groupTwoData.length
  const prefix = round === "1"
    ? groupTwoData
      ? 'first'
      : ''
    : 'second'

  return (
    <div className={"d3-c-greatest-moment__progress d3-o-progress"}>
      <div className="d3-o-progress__header">
        {`Select ${maxCount}`}
      </div>
      <div className="d3-o-progress__subheader">
        {`Please select ${maxCount} from the ${prefix} set of ${groupLength} moments below`}
      </div>
      <div className="d3-o-progress__subheader">
        {`Click each image to relive the moment`}
      </div>
      {
        groupTwoData && (
          <div className="d3-o-progress__bar">
            {round === '1' ? <FirstRound /> : <SecondRound />}
          </div>
        )
      }
    </div>
  );
}

export const GridWrap = ({ children }) => {
  return (
    <Fragment>
      {children && (
        <div className="d3-l-grid--outer">
          <div className="d3-l-grid--inner">
            {React.Children.map(children, (child, index) => {
              const columnSize =
                child && child.props && child.props.columnSize
                  ? child.props.columnSize
                  : "12";
              return (
                <div key={index} className={`d3-l-col__col-${columnSize}`}>
                  {child}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export function PositionIndicator(props) {
  const { selected, positionShort, isActive, selectPosition, closeNavModal} = props;

  const onClick = closeNavModal ? closeNavModal : selectPosition

  return (
    <div onClick={onClick} className={`d3-o-position-indicator ${selected ? "selected" : ""} ${isActive ? "active" : "unactive"}`}>
      <PlayerPosition baseClass={"d3-o-position-indicator"} position={positionShort} />
    </div>
  );
}

export function MomentDetails(props) {
  const { fields, thumbnail, references } = props || {};
  const { headline, description, roofline, homeTeam, awayTeam } = fields || {}


  const { firstLayer } = references || {}
  const highlightVideo = firstLayer && firstLayer[0] || null


  const baseClass = 'd3-o-card';
  const responsive = useSelector(state => state.responsive)
  const { isPhone, isTablet, isDesktop } = responsive || {}

  const type = "details"

  const { square, portrait } = getImageFormat(null, isPhone ? "w_300,f_png" : "w_500,f_png");
  const { landscape } = getImageFormat(null, isPhone ? "w_300,f_auto" : "w_600,f_auto");

  const momentImage =
    thumbnail &&
    formatImage(thumbnail, firstLayer ? square : landscape);

  return (

    <div className="d3-c-greatest-moment__details">
      <MediaObject
        clickFn={null}
        type={type}
      >
        <MediaObjectFigure type={type}>
          <MediaLayerGroup
            isMobile={isPhone || isTablet}
            baseClass={baseClass}
            className={firstLayer ? "video" : "photo"}
          >
            {
              firstLayer ? <CloudinaryVideoPlayer playsInline={true} highlightVideo={highlightVideo} baseClass={baseClass} includeBody={false} overlayImage={momentImage} /> 
                : (
                  <MediaLayer
                    type={type}
                    baseClass={baseClass}
                    layerNumber="three"
                    isLazy={false}
                    image={momentImage}
                  />
                )
            }
          </MediaLayerGroup>
        </MediaObjectFigure>
        <div className="d3-o-media-object__body">
          <div className="d3-o-media-object__content">
            {headline && (
              <div className={`${baseClass}__data-section-header`}>
                <h2>{headline}</h2>
              </div>)
            }
            {roofline && (
              <div className={`${baseClass}__data-section-date`}>
                <ReactMarkdown
                  escapeHtml={false}
                  source={roofline} />
              </div>)
            }
            {homeTeam && (
              <div className={`${baseClass}__data-section-teams`}>
                <ReactMarkdown
                  escapeHtml={false}
                  source={homeTeam} />
              </div>)
            }
            {description && (
                <div className={`${baseClass}__data-section-body`}>
                  <ReactMarkdown
                    escapeHtml={false}
                    source={description} />
                </div>
              )
              }
          </div>
        </div>
      </MediaObject>
      </div>
  );
}

export function PlayerDetails(props) {
  const { fields, thumbnail, highlightVideo } = props || {};

  const {
    playerPosition,
    firstName,
    lastName,
    biography,
    yearsActive,
    backgroundType
  } = fields || {};

  const baseClass = 'd3-o-card';
  const responsive = useSelector(state => state.responsive)
  const { isPhone, isTablet, isDesktop } = responsive || {}

  const type = "details"

  const backgroundList = useSelector(state => state.backgrounds)
  const parsed = backgroundType && typeof backgroundType === "number" ? parseInt(backgroundType, 10) : 0;
  const background = backgroundList && backgroundList.length > 0 ? backgroundList[parsed] : null

  const { square, portrait } = getImageFormat(null, isPhone ? "w_300,f_png" : "w_500,f_png");
  const { landscape } = getImageFormat(null, isPhone ? "q_70,w_300,f_auto" : "q_70,w_600,f_auto");
   
  const playerImage =
    thumbnail &&
    formatImage(thumbnail, square);

  const backgroundImage =
    background &&
    formatImage(background, isPhone || isTablet ? portrait : landscape);

  return (
    <div className={`d3-o-player ${highlightVideo ? "d3-o-player--video" : ""} d3-o-player--details`}>
      <MediaObject
        clickFn={null}
        type={type}
      >
        <MediaObjectFigure type={type}>
          <MediaLayerGroup
            isMobile={isPhone || isTablet}
            baseClass={baseClass}
            className={highlightVideo ? "video" : "photo"}
          >
            {highlightVideo
              ? <CloudinaryVideoPlayer playsInline={true} highlightVideo={highlightVideo} baseClass={baseClass} includeBody={false} overlayImage={playerImage} />
              : (
                  <>
                    <div className={"d3-o-card__overlay"} />
                    <MediaLayer
                      type={type}
                      baseClass={baseClass}
                      layerNumber="two"
                      isLazy={false}
                      image={playerImage}
                    />
                    <MediaLayer type={type} baseClass={baseClass} image={backgroundImage} layerNumber="three" isLazy={false} />
                  </>              
              )
            }
          </MediaLayerGroup>
        </MediaObjectFigure>  
        <div className="d3-o-media-object__body">
          <PlayerName
            firstName={firstName}
            lastName={lastName}
            playerPosition={playerPosition}
            yearsActive={yearsActive}
          />
          <PlayerData fields={fields} highlightVideo={null} />
        </div>
      </MediaObject>
    </div>
  );
}

export function PlayerName({
  firstName,
  lastName,
  yearsActive,
  playerPosition
}) {
  return (
    <div className="d3-o-player-name">
      <div className="d3-o-player-name__name-container">
        <div className="d3-o-player-name__first-name">{firstName}</div>
        <div className="d3-o-player-name__last-name">{lastName}</div>
      </div>
      <div className="d3-o-player-name__info-container">
        <PlayerPosition baseClass={"d3-o-player-name"} position={playerPosition} />
        <div className="d3-o-player-name__years-active">{yearsActive}</div>
      </div>
    </div>
  );
}

export function PlayerData(props) {
  const { highlightVideo, fields } = props;
  const { biography, teamsData, keyStatsOne } = fields || {}

  return (
    <div className="d3-o-player__data-container">
      <DataSection sectionText={biography} sectionName={"bio"} />
      <div className={`d3-o-player__key-accomplishments-container`}>
        <h2 className={`d3-o-player__data-section-header`}>Key Accomplishments</h2>
        <KeyAccomplishments count={6} fields={fields} />
      </div>
      {teamsData && <div className={`d3-o-player__teams-container`}>
        <h2 className={`d3-o-player__data-section-header`}>Teams</h2>
        <Teams teamsData={teamsData} />
      </div>}
      {keyStatsOne && <div className={`d3-o-player__key-stats-container`}>
        <h2 className={`d3-o-player__data-section-header`}>Key Stats</h2>
        <KeyStats fields={fields} />
      </div>}
      <DataSection sectionVideo={highlightVideo} sectionName={"highlights"} />
    </div>
  );
}



function DataSection(props) {
  const { sectionText, sectionVideo, sectionName } = props;

  return (
    sectionText || sectionVideo ?     
      <div className={`d3-o-player__${sectionName}-container`}>
        <h2 className={`d3-o-player__data-section-header`}>{sectionName}</h2>
        {sectionText && <p className={`d3-o-player__data-section-body`}>{sectionText}</p>}
        {sectionVideo && <CloudinaryVideoPlayer highlightVideo={sectionVideo} baseClass={'d3-o-player'} />}
      </div>
    : null
  );
}

export const DataSteps = props => {
  const { stepPosition, bodyText, baseClass } = props;
  return (
    <div className={`${baseClass}__data-steps`}>
      <h2 className={`${baseClass}__data-steps-header`} >{`Step ${stepPosition}.`}</h2>
      <p className={`${baseClass}__data-steps-body`}>{bodyText}</p>
    </div>
  );
};

export function PlayerSidebar({ currentPlayer, baseClass, highlightVideo }) {

  const sidebarRef = useRef(null)
  const prevPlayer = usePrevious(currentPlayer)

  useEffect(() => {
    if (prevPlayer) {
      if (prevPlayer.title !== currentPlayer.title) {
        sidebarRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }, [currentPlayer])

  const { fields } = currentPlayer || {};
  const { firstName, lastName, playerPosition, yearsActive, biography, mvpData, allProData, proBowlData, championshipData, superBowlMvpData, hallOfFameData } = fields || {}

  return (
    <div ref={sidebarRef} className={`${baseClass}__player-sidebar`}>
      <PlayerName
        firstName={firstName}
        lastName={lastName}
        playerPosition={playerPosition}
        yearsActive={yearsActive}
      />
      <PlayerData fields={fields} highlightVideo={highlightVideo} />
    </div>
  );
}

export function LeaderboardRankings({ openModal, setCurrentItem, currentPosition, module, isLeaderboardEnabled = true }) {
  const { feUrl } = useSelector(state => state.envData)
  const [leaderboard, setLeaderboard] = useState(null)

  const backgroundList = useSelector(state => state.backgrounds)
  const background = backgroundList && backgroundList.length > 0 ? backgroundList[0] : null

  const type = "leaderboard"
  const { positionShort, players, maxCount } = currentPosition || {}
  const rankings = module === 'allTimeTeam'
    ? `${feUrl}/api/prediction/leaderboard/position/${positionShort}`
    : `${feUrl}/api/moment/leaderboard`


  const { data, error } = useSWR(rankings, module === 'greatestMoment' ? fetchMoments : fetchItems)


  if (error) {
    return (
      <div className={`d3-o-leaderboard__list`}>
        <ErrorLoading />
      </div>
    )
  }


  useEffect(() => {
    function formattedPlayers(data) {
      return data && data.map(item => {
        const changedCase = item.playerData

        const { entityId, selfUrl, slug, title, division, firstName, lastName, yearsActive, displayName, preferredTeam, careerLength, thumbnail, ...otherProps } = changedCase || {}
        const { votes, votesPercent, votesPercentValue, totalVotes, ...other } = item

        const formattedVotePercentage = calcVotePercentage({ votes, totalVotes, maxCount })
        return {
          votes,
          votesPercent,
          votesPercentValue,
          formattedVotePercentage,
          totalVotes,
          _entityId: entityId,
          selfUrl,
          slug,
          title,
          thumbnail,
          fields: {
            division, displayName, preferredTeam, careerLength, firstName, lastName, yearsActive
          }
        }
      })
    }

    function formattedMoments(data) {
      return data && data.map(item => {
        const { moment, totalVotes } = item || {}
          const { fields, selfUrl, entityId, translationId, thumbnail, videoData, slug } = moment || {}
          return {
            fields,
            translationId,
            selfUrl,
            slug,
            entityId,
            thumbnail,
            videoData,
            totalVotes
          }
        })
    }


    setLeaderboard(module === 'allTimeTeam' ? formattedPlayers(data) : formattedMoments(data))
  }, [data, module])

  const backgroundImage =
    background &&
    formatImage(background, getImageFormat("h_50,w_50", 'f_auto').custom);

  return (
    <div className={`d3-o-leaderboard__list`}>
      {!leaderboard
        ? <div>LOADING...</div>
        : leaderboard.map((item, index) => {
            if (index < 10) {
              return (
                <LeaderboardRank
                  backgroundImage={backgroundImage}
                  type={type}
                  key={index}
                  index={index}
                  item={item}
                  setCurrentItem={setCurrentItem}
                  openModal={openModal}
                  module={module}
                />
              )
            }
          }
        )
      }
    </div>
  );
}

const LeaderboardRank = ({ item, index, setCurrentItem, type, openModal, backgroundImage, module }) => {
  const { fields, formattedVotePercentage, thumbnail } = item || {};

  const thumbnailImage =
    thumbnail &&
    formatImage(
      thumbnail,
      module === 'allTimeTeam'
        ? getImageFormat("h_40,w_40", "f_png").custom
        : getImageFormat("h_40,w_40,c_fill,g_north", "f_auto").custom
    );

  const showDetails = e => {
    setCurrentItem(item);
    openModal(e);
  }

  const { displayName, headline } = fields || {};
  return (
    <div className={"d3-o-leaderboard__rank"}>
      <div className={"d3-o-leaderboard__rank-container"}>
        <div className={"d3-o-leaderboard__rank-number"}>
          {`#${index + 1}`}
        </div>
        <MediaObject>
          <MediaObjectFigure>
            <MediaLayer
              type={type}
              baseClass={'d3-o-card'}
              layerNumber="two"
              isLazy={false}
              image={thumbnailImage}
            />
            <MediaLayer type={type} baseClass={'d3-o-card'} image={backgroundImage} layerNumber="three" isLazy={false} />
          </MediaObjectFigure>
          <div className="d3-o-media-object__body">
            <div className={`d3-o-media-object__display-name`}>
              {module === 'allTimeTeam' ? displayName : headline}
            </div>
            {formattedVotePercentage && <div className={`d3-o-media-object__votes`}>
              {`${formattedVotePercentage}`}
            </div>}
          </div>
        </MediaObject>
      </div>
      <div className={'d3-o-leaderboard__modal-icon'} onClick={showDetails} >
        <ModalIcon />
      </div>
    </div>
  );
}

export const FanVoteRank = ({ player, votesPercentValue, index, backgroundImage, type = "fanVote", isSelected = false }) => {

  const { displayName, thumbnail, yearsActive } = player || {};
  const thumbnailImage =
    thumbnail &&
    formatImage(
      thumbnail,
      getImageFormat("h_40,w_40", "f_png").custom
    );

  return (
    <div className={"d3-o-fan-vote-leaderboard__rank"}>
      <div className={`d3-o-fan-vote-leaderboard__rank-container ${isSelected ? "selected" : ""}`}>
        <div className={"d3-o-fan-vote-leaderboard__rank-number"}>
          {`#${index + 1}`}
        </div>
        <MediaObject>
          <MediaObjectFigure>
            <MediaLayer
              type={type}
              baseClass={'d3-o-card'}
              layerNumber="two"
              isLazy={false}
              image={thumbnailImage}
            />
            <MediaLayer type={type} baseClass={'d3-o-card'} image={backgroundImage} layerNumber="three" isLazy={false} />
          </MediaObjectFigure>
          <div className="d3-o-media-object__body">
            <div className={`d3-o-media-object__display-name`}>
              {displayName}
            </div>
            <div className={`d3-o-media-object__years-active`}>
              {yearsActive}
            </div>
          </div>
        </MediaObject>
        <div className="d3-o-fan-vote-leaderboard__info">
          {isSelected && <div className="d3-o-fan-vote-leaderboard__all-time-team-selection"><AllTimeTeamLogo /></div>}
          <div className={`d3-o-fan-vote-leaderboard__votes`}>{`${votesPercentValue}`}</div>
        </div>
      </div>
    </div>
  );
}

export const LeaderboardHeader = ({ module}) => (
  <h2 className="d3-o-leaderboard__header" >
    <div className="d3-o-leaderboard__header-top" >{`${module === 'allTimeTeam' ? "ALL-TIME TEAM" : "GREATEST MOMENT"} LEADERBOARD`}</div>
    <div className="d3-o-leaderboard__header-bottom">VOTED BY FANS</div>
  </h2>  
)

export const PlayerSelection = ({ item, backgroundImage }) => {
  const { fields, thumbnail } = item || {};
  const { firstName, lastName } = fields || {};

  const thumbnailImage =
    thumbnail &&
    formatImage(
      thumbnail,
      getImageFormat(null, "h_40,w_40,f_auto").thumbnail
    );

  return (
    <MediaObject >
      <MediaObjectFigure>
        <MediaLayer
          isMoment={false}
          baseClass={'d3-o-card'}
          layerNumber="two"
          isLazy={false}
          image={thumbnailImage}
        />
        <MediaLayer isMoment={false} baseClass={'d3-o-card'} image={backgroundImage} layerNumber="three" isLazy={false} />
      </MediaObjectFigure>
      <div className="d3-o-media-object__body">
        <div className={`d3-o-media-object__first-name`}>
          {firstName}
        </div>
        <div className={`d3-o-media-object__last-name`}>
          {lastName}
        </div>
      </div>
    </MediaObject>
  );
}

export function CloudinaryVideoPlayer(props) {
  const { highlightVideo, baseClass, playsInline, overlayImage = null, includeBody = true, useOverlay = false } = props
  const { env, cloudName } = useSelector(state => state.envData)
  const posterData = useSelector(state => state.videoPosterUrl)
  const { highQuality } = posterData && formatImageUrl(posterData, getImageFormat(null, 'f_auto').landscape) || {};



  const { fields } = highlightVideo || {}
  const { videoData, headline, description } = fields || {}
  const { public_id, secure_url, thumbnail_url, url } = videoData || {}

  const config = cloudName === "deltatrenfl100" ? {}
    : {
      cname: "static.clubs.nfl.com",
      secure_distribution: "static.clubs.nfl.com",
      private_cdn: true,
      secure: true,
    }

  return (
    <>
      <CloudinaryVideo
        className="cld-video-player cld-video-player-skin-dark cld-fluid"
        cloudName={cloudName}
        playsInline={playsInline}
        controls
        muted
        config={config}
        source={{
          publicId: public_id,
          poster: overlayImage && useOverlay ? overlayImage : highQuality
        }}
      />
      {includeBody && (
        <>
          <h3 className={`${baseClass}__data-section-sub-header`}>
            <ReactMarkdown
              escapeHtml={false}
              source={headline} />
          </h3>
          <div className={`${baseClass}__data-section-body`}>
            <ReactMarkdown
              escapeHtml={false}
              source={description} />
            </div>
          </>
        )
      }

    </>
  )
}

function CloudinaryVideo({ id, controls, muted, cloudName, config, source, playsInline }) {

  const videoRef = useRef(null)
  useEffect(() => {
    if (cloudinary) {
      const cloudinaryCore = new window.cloudinary.Cloudinary({
        cloud_name: cloudName,
        ...config
      });

      const player = cloudinaryCore.videoPlayer(
        videoRef.current || id || "cld-video-player",
      );

      if (cloudName === 'nflclubs') {
        player.source(source, { sourceTypes: ['hls'], transformation: { streaming_profile: 'hd' } });
      }
      else {
        player.source(source);
      }

      player.fluid(true)

      const $videoElement = player.el();
      const $playButton = $videoElement.querySelector('button.vjs-big-play-button')
      appendPlayButton($playButton);
      makeButtonVisible($playButton);
    }
  }, [cloudinary])

  return (
    <video
      playsInline={playsInline}
      ref={videoRef}
      id={id || "cld-video-player"}
      controls={controls}
      muted={muted}
    />
  );
}

export const ErrorLoading = () => {
  return (
    <div>Error Loading Data...</div>
  )
}

export const Loading = ({ isLoading, className }) => {
  return (
    <div className={`${className ? className : ''} d3-o-loading`}>
      <div className="d3-o-loading__label">
        LOADING...
      </div>
      <DotLoader
        sizeUnit={"px"}
        size={20}
        color={'#d4af37'}
        loading={isLoading}
      />
    </div>
  )
}


export const Lockup = ({ isSelected, rank, firstName, lastName, yearsActive, votesPercentValue }) => {
  return (
    <div className={`d3-o-lockup ${isSelected ? "selected" : ""}`}>
      <div className="d3-o-lockup__row d3-o-lockup__row--1">
        <div className="d3-o-lockup__rank">{`#${rank}`}</div>
        {
          isSelected &&
          <div className="d3-o-lockup__all-time-team-selection">
            <AllTimeTeamLogo />
          </div>
        }
      </div>
      <div className="d3-o-lockup__row d3-o-lockup__row--2">
        {firstName && <div className="d3-o-lockup__first-name">{firstName}</div>}
        {lastName && <div className="d3-o-lockup__last-name">{lastName}</div>}
      </div>
      <div className="d3-o-lockup__row d3-o-lockup__row--3">
        {yearsActive && <div className="d3-o-lockup__years-active">{yearsActive}</div>}
      </div>
      <div className="d3-o-lockup__row d3-o-lockup__row--4">
        {votesPercentValue && <div className="d3-o-lockup__votes-percent">{votesPercentValue}</div>}
      </div>
    </div>  
  )
}


const CLOSE_TIMEOUT = 500;

export function SlidingPane({
  isOpen,
  title,
  subtitle,
  onRequestClose,
  onAfterOpen,
  children,
  className,
  overlayClassName,
  closeIcon,
  from = "bottom",
  width,
  shouldCloseOnEsc
}) {
  const directionClass = `slide-pane_from_${from}`;

  return (
    <ReactModal
      className={`slide-pane ${directionClass} ${className || ""}`}
      style={{
        content: { width: width || "80%" }
      }}
      overlayClassName={`slide-pane__overlay ${overlayClassName || ""}`}
      closeTimeoutMS={CLOSE_TIMEOUT}
      isOpen={isOpen}
      shouldCloseOnEsc={shouldCloseOnEsc}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      contentLabel={`Modal "${title || ""}"`}
    >
      {title && <div className="slide-pane__header">
        <button className="slide-pane__close" onClick={onRequestClose}>
          {closeIcon ? closeIcon : <IconClose />}
        </button>
        <div className="slide-pane__title-wrapper">
          <h2 className="slide-pane__title">{title}</h2>
          <div className="slide-pane__subtitle">{subtitle}</div>
        </div>
      </div>}
      <div className="slide-pane__content">{children}</div>
    </ReactModal>
  );
}

function IconClose() {
  return (
    <svg
      id="Layer_4"
      className="d3-o-button__x"
      data-name="Layer 4"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      data-micromodal-close=""
    >
      <title>ic</title>
      <polygon points="13.41 12 18.21 7.21 16.79 5.79 12 10.59 7.21 5.79 5.79 7.21 10.59 12 5.79 16.79 7.21 18.21 12 13.41 16.79 18.21 18.21 16.79 13.41 12" />
      <rect className="cls-1" width="24" height="24" />
      <rect className="cls-1" width="24" height="24" />
    </svg>
  );
}

export const SubmissionHeader = ({ selectedItems, currentPosition, positionLong, module }) => {


  return (
    <h2 className="d3-o-submissions__header" >
      <div className={`d3-o-submissions__header-top`}>
        {selectedItems && selectedItems.length > 0
          ? "THANKS FOR VOTING!" : ""}
      </div>
      {module === 'greatestMoment'
        ? selectedItems && selectedItems.length > 0 ? (
          <div className={`d3-o-submissions__header-bottom`}>
            {selectedItems.length > 1
                  ? `Here are your ${selectedItems.length} NFL Greatest Moments!`
                  : `Here is your NFL Greatest Moment!`}
              </div>
            ) : (
                <div className={`d3-o-submissions__header-bottom`}>
                  Vote for your NFL Greatest Moments!
                </div>
            )          
        : currentPosition
          ? (
              <div className={`d3-o-submissions__header-bottom`}>
              {selectedItems && selectedItems.length > 0
                  ? `Here is your All-Time Team ${positionLong} selection`
                  : `All-Time Team ${positionLong} selection`}
              </div>
          ) : (
            <div className={`d3-o-submissions__header-bottom`}>
              Predict your NFL All-Time Team!
            </div>
          )
      }
    </h2>  
  )
}

export const SubmissionSelections = memo(props => {
  const { items } = props
  const responsive = useSelector(state => state.responsive)

  const imageFormat = { format: "t_portrait_mobile", extension: "f_auto" }

  return (
    <div className={`d3-o-submissions__user-selections ${items && items.length === 1 ? "single" : ""}`}>
      {
        items
          ? <MomentSubmissions items={items} selectionLength={items.length} imageFormat={imageFormat} />
          : <Loading className="d3-o-submissions__loading" />
      }
    </div>
  )
})

const MomentSubmissions = memo(props => {
  const { items, selectionLength, imageFormat } = props || {}
  const responsive = useSelector(state => state.responsive)
  const { isDesktop } = responsive || {}

  return items.map((item, index) => {
    const { _entityId, entityId, fields } = item || {}

    const id = _entityId || entityId
    return (
      <div key={id ? id : index} className={`d3-c-greatest-moment__card-container`}>
        {
          selectionLength === 1 ? (
            <>
              {fields && <CardText headline={fields.headline} homeTeam={fields.homeTeam} />}
              <div className={`d3-o-card d3-o-card--moment selected`}>
                <CardImage
                  imageFormat={imageFormat}
                  isSelected={true}
                  image={item.thumbnail}
                  entityId={item._entityId}
                  openCard={null}
                  clickFn={null}
                />
              </div>
            </>
          ) : (
              <>
                <Card cardType="moment" isSelected={true} >
                  <CardImage
                    imageFormat={imageFormat}
                    isSelected={true}
                    image={item.thumbnail}
                    entityId={item._entityId}
                    openCard={null}
                    clickFn={null}
                  />
                </Card>
                <CardText headline={fields.headline} homeTeam={fields.homeTeam} />
              </>
            )
        }

      </div>
    )
  })
})


export const SubmissionShare = ({ currentPosition, selectedItems, submissionItems, setIsShareButton, openModal, module, voteAgain }) => {
  const RenderPlayerShare = () => {
    return (
    <>
        {currentPosition && selectedItems && selectedItems.length > 0 && (
          <Button
            className="d3-o-submissions__button share"
            isEnabled={true}
            clickFn={e => {
              setIsShareButton(true)
              openModal(e)
            }}
            buttonText="SHARE YOUR PREDICTION"
          />
        )}
      {currentPosition
        ? <Button
          className="d3-o-submissions__button vote"
          color="black"
          clickFn={voteAgain}
          buttonText={selectedItems && selectedItems.length > 0
            ? `PREDICT AGAIN`
            : `PREDICT NOW`}
          isEnabled={true} />
        : <Button
          className="d3-o-submissions__button vote"
          color="black"
          clickFn={voteAgain}
          buttonText={"PREDICT NOW"}
          isEnabled={true} />
        }    
      </>
    )
  }

  const RenderMomentShare = () => {
    return (
      <>
        {selectedItems && selectedItems.length > 0 && (
          <Button
            className="d3-o-submissions__button share"
            isEnabled={true}
            clickFn={e => {
              setIsShareButton(true)
              openModal(e)
            }}
            buttonText="SHARE YOUR VOTE"
          />
        )}
        {submissionItems
          ? <Button
            className="d3-o-submissions__button vote"
            color="black"
            clickFn={voteAgain}
            buttonText={selectedItems && selectedItems.length > 0
              ? `VOTE AGAIN`
              : `VOTE NOW`}
            isEnabled={true} />
          : <Button
            className="d3-o-submissions__button vote"
            color="black"
            clickFn={voteAgain}
            buttonText={"VOTE NOW"}
            isEnabled={true} />
        }
      </>
    )
  }

  return (
    <>
      {
        module === 'allTimeTeam'
          ? <RenderPlayerShare /> 
          : <RenderMomentShare />
      }  
    </>
  )
}